// Change this value for the speed of the animations.
export const ANIMATION_SPEED_MS = 5;
export const ANIMATION_SPEED_MAX = 50;
export const ARRAY_SIZE_MAX = 200;
export const ARRAY_VALUE_MAX = 500;
// This is the main color of the array bars.
export const PRIMARY_COLOR = 'Navy';
export const gitLink = 'https://github.com/jinlee487/sorting-visualizer-jayleecodes';
export const blogLink = 'https://jinlee487.github.io/';
// This is the color of array bars that are being compared throughout the animations.
export const SECONDARY_COLOR = 'Yellow';
export const SUCCESS_COLOR = '#009933';
